import * as BaseApi from "api/Base.api";
import { IPagination, ILikeToggleResponse } from "api/interfaces/common.interface";
import {
    IChallenge,
    IChallengeCreateRequest,
    IChallengeUpdateRequest,
    IChallengeDiaryAddRequest,
    IChallengeListResponse,
    IChallengeDetailResponse,
    IChallengeDiaryListResponse,
    IChallengeCreateResponse,
    IChallengeUpdateResponse,
    IChallengeDeleteResponse,
    IChallengeJoinResponse,
    IChallengeStatsResponse
} from "api/interfaces/profile.interface";

// 챌린지 목록 조회
export const challengeList = async (params?: {
    page?: number;
    limit?: number;
    isPublic?: boolean;
    userId?: string;
    search?: string;
}): Promise<IChallengeListResponse> => {
    try {
        const response = await BaseApi.get("/student/v2/challenge", params);
        return response as IChallengeListResponse;
    } catch (error) {
        console.error("챌린지 목록 조회 실패:", error);
        throw error;
    }
};

// 챌린지 상세 조회
export const challenge = async (challengeId: string): Promise<IChallengeDetailResponse> => {
    try {
        const response = await BaseApi.get(`/student/v2/challenge/${challengeId}`);
        return response as IChallengeDetailResponse;
    } catch (error) {
        console.error("챌린지 상세 조회 실패:", error);
        throw error;
    }
};

// 챌린지 생성
export const createChallenge = async (challengeData: IChallengeCreateRequest): Promise<IChallengeCreateResponse> => {
    try {
        const response = await BaseApi.post2("/student/v2/challenge", challengeData);
        return response as IChallengeCreateResponse;
    } catch (error) {
        console.error("챌린지 생성 실패:", error);
        throw error;
    }
};

// 챌린지 수정
export const updateChallenge = async (challengeId: string, challengeData: IChallengeUpdateRequest): Promise<IChallengeUpdateResponse> => {
    try {
        const response = await BaseApi.put(`/student/v2/challenge/${challengeId}`, challengeData);
        return response as IChallengeUpdateResponse;
    } catch (error) {
        console.error("챌린지 수정 실패:", error);
        throw error;
    }
};

// 챌린지 삭제
export const deleteChallenge = async (challengeId: string): Promise<IChallengeDeleteResponse> => {
    try {
        const response = await BaseApi.remove2(`/student/v2/challenge/${challengeId}`);
        return response as IChallengeDeleteResponse;
    } catch (error) {
        console.error("챌린지 삭제 실패:", error);
        throw error;
    }
};

// 챌린지 참여
export const joinChallenge = async (challengeId: string): Promise<IChallengeJoinResponse> => {
    try {
        const response = await BaseApi.post2(`/student/v2/challenge/${challengeId}/join`);
        return response as IChallengeJoinResponse;
    } catch (error) {
        console.error("챌린지 참여 실패:", error);
        throw error;
    }
};

// 챌린지 탈퇴
export const leaveChallenge = async (challengeId: string): Promise<IChallengeJoinResponse> => {
    try {
        const response = await BaseApi.post2(`/student/v2/challenge/${challengeId}/leave`);
        return response as IChallengeJoinResponse;
    } catch (error) {
        console.error("챌린지 탈퇴 실패:", error);
        throw error;
    }
};

// 챌린지 다이어리 목록 조회
export const challengeDiaryList = async (challengeId: string, params?: {
    page?: number;
    limit?: number;
}): Promise<IChallengeDiaryListResponse> => {
    try {
        const response = await BaseApi.get(`/student/v2/challenge/${challengeId}/diary`, params);
        return response as IChallengeDiaryListResponse;
    } catch (error) {
        console.error("챌린지 다이어리 목록 조회 실패:", error);
        throw error;
    }
};

// 챌린지에 다이어리 추가
export const addChallengeDiary = async (challengeId: string, diaryData: IChallengeDiaryAddRequest): Promise<void> => {
    try {
        await BaseApi.post(`/student/v2/challenge/${challengeId}/diary`, diaryData);
    } catch (error) {
        console.error("챌린지 다이어리 추가 실패:", error);
        throw error;
    }
};

// 챌린지에서 다이어리 제거
export const removeChallengeDiary = async (challengeId: string, diaryId: string): Promise<void> => {
    try {
        await BaseApi.remove(`/student/v2/challenge/${challengeId}/diary/${diaryId}`);
    } catch (error) {
        console.error("챌린지 다이어리 제거 실패:", error);
        throw error;
    }
};

// 챌린지 통계 조회
export const challengeStats = async (): Promise<IChallengeStatsResponse> => {
    try {
        const response = await BaseApi.get("/student/v2/challenge/stats");
        return response as IChallengeStatsResponse;
    } catch (error) {
        console.error("챌린지 통계 조회 실패:", error);
        throw error;
    }
};

// 챌린지 좋아요 토글
export const toggleChallengeLike = async (challengeId: string): Promise<ILikeToggleResponse> => {
    try {
        const response = await BaseApi.post2(`/student/v2/challenge/${challengeId}/like`);
        return response as ILikeToggleResponse;
    } catch (error) {
        console.error("챌린지 좋아요 토글 실패:", error);
        throw error;
    }
};

// 챌린지 감추기 토글
export const toggleChallengeHidden = async (challengeId: string): Promise<{ isHidden: boolean; message: string }> => {
    try {
        const response = await BaseApi.post2(`/student/v2/challenge/${challengeId}/hidden`);
        return response as { isHidden: boolean; message: string };
    } catch (error) {
        console.error("챌린지 감추기 토글 실패:", error);
        throw error;
    }
};
